export default __webpack_public_path__ + "static/media/website_cover_mobimageEn.607363d7.jpg";